import React, { useEffect, useRef, useState } from 'react';
import { Box, Grid, Typography, Button, useTheme } from '@mui/material';
import { NavLink } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { useLanguage } from '../../LanguageContext';
import { useIntl } from 'react-intl';

const MobileHeader = ({ headerLinks, languages }) => {
	const { $t } = useIntl();
	const { changeLocale } = useLanguage();

	const [open, setOpen] = useState(false);
	const [closing, setClosing] = useState(false);
	const theme = useTheme();
	const menuRef = useRef(null);

	const handleClickOutside = event => {
		if (menuRef.current && !menuRef.current.contains(event.target)) {
			setClosing(true);
			setTimeout(() => {
				setOpen(false);
				setClosing(false);
			}, 500);
		}
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	});

	return (
		<Grid
			bgcolor={theme.palette.primary.one}
			py={'21px'}
			px={'16px'}
			display={'flex'}
			alignItems={'center'}
			justifyContent={'space-between'}
		>
			<Grid>
				<div
					onClick={() => {
						setClosing(false);
						setOpen(true);
					}}
				>
					<MenuIcon
						fontSize={'large'}
						style={{ cursor: 'pointer' }}
					/>
				</div>
				{open === true && (
					<AnimatedGrid
						menuRef={menuRef}
						closing={closing}
					>
						{headerLinks.map(({ link, title }) => (
							<NavLink
								key={title}
								to={link}
								onClick={() => {
									setClosing(true);
									setTimeout(() => {
										setOpen(false);
										setClosing(false);
									}, 500);
								}}
							>
								{({ isActive }) => (
									<>
										<Typography
											color={theme.palette.secondary.one}
											px={'30px'}
											display={'flex'}
											alignItems={'center'}
											justifyContent={'center'}
											py={'8px'}
											fontSize={isActive ? 20 : 16}
											fontWeight={isActive ? 900 : 500}
											style={{ cursor: 'pointer' }}
										>
											{$t({ id: title })}
										</Typography>
										<Box
											bgcolor={'rgba(68, 74, 93, 0.50)'}
											width={'100%'}
											height={'1px'}
										></Box>
									</>
								)}
							</NavLink>
						))}
						<Box
							display={'flex'}
							gap={'10px'}
							alignItems={'center'}
							justifyContent={'center'}
							height={'max-content'}
							pt={'15px'}
							width={'100%'}
						>
							{languages?.map(({ title, symbol, id }, index) => (
								<Button
									key={index}
									style={{
										backgroundColor:
											localStorage.getItem('userLocale') === id
												? 'rgba(68, 74, 93, 1)'
												: 'rgba(255, 191, 63, 1)',
										color:
											localStorage.getItem('userLocale') === id
												? 'white'
												: 'rgba(68, 74, 93, 1)',
										border:
											localStorage.getItem('userLocale') === id
												? 'none'
												: '1px solid rgba(68, 74, 93, 1)',
										minWidth: '24px',
										width: 'max-content',
										height: '20px',
										padding: '0px',
										display: 'flex',
										alignItems: 'flex-start',
										justifyContent: 'center',
										borderRadius: '3px',
										fontSize: '12px',
									}}
									onClick={() => {
										changeLocale(symbol);
									}}
								>
									{title}
								</Button>
							))}
						</Box>
					</AnimatedGrid>
				)}
			</Grid>
			<Grid>
				<img
					src={'/assets/Images/Altyn.svg'}
					alt={'Altyn'}
				/>
			</Grid>
		</Grid>
	);
};

const AnimatedGrid = ({ closing, children, menuRef }) => {
	const theme = useTheme();
	const { locale } = useLanguage();

	//console.log(closing);

	return (
		<div
			style={{
				animation: closing ? `fadeOut 0.25s forwards` : `fadeIn 0.25s`,
			}}
		>
			<Box
				borderColor={theme.palette.primary.one}
				position={'absolute'}
				style={{ boxShadow: '0px 2px 10px 0px rgba(0, 0, 0, 0.25)' }}
				borderRadius={locale === 'fa' ? '0 0 0 20px' : '0 0 20px 0'}
				top={0}
				left={locale === 'fa' ? 'auto' : 0}
				right={locale === 'fa' ? 0 : 'auto'}
				zIndex={10}
				ref={menuRef}
				bgcolor={theme.palette.primary.one}
				border={'none'}
				p={'24px 32px 16px 32px'}
			>
				{children}
			</Box>
		</div>
	);
};

export default MobileHeader;
